import { all, call } from 'redux-saga/effects';
import { paymentIntegritySaga } from './paymentIntegritySaga/paymentIntegritySaga';
import { overPaymentSaga } from './overPaymentSaga/overPaymentSaga';
import { paymentIntegrityDetailsSaga } from './paymentIntegrityDetailsSaga/paymentIntegrityDetailsSaga';
import { appealSaga } from './appealSaga/appealSaga';
import { nonPaymentSaga } from './nonPaymentSaga/nonPaymentSaga';
import { paymentsSaga } from './paymentsSaga/paymentsSaga';
import { settlementSaga } from './settlementSaga/settlementSaga';
import { reiumbursementTabsSaga } from './reimbursementTabsSaga/reimbursementTabsSaga';

export function* reimbursementSaga() {
  yield all([
    call(paymentIntegritySaga),
    call(overPaymentSaga),
    call(paymentIntegrityDetailsSaga),
    call(appealSaga),
    call(nonPaymentSaga),
    call(paymentsSaga),
    call(settlementSaga),
    call(reiumbursementTabsSaga),
  ]);
}
